@import '~style-sheet-helpers/core.less';

.restore-results-modal-body {
  padding: 16px 16px 64px;
}

.restore-results-body-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.helper-text {
  font-size: 20px;
  line-height: 1.5;
  font-weight: 400;
}

.restore-results-modal-header {
  font-size: 16px;
}

.restore-results-modal-footer {
  .close-button {
    margin-left: 10px;
  }
}
